import Model from './Model'

export default class ProductReview extends Model {
    resource()
    {
        return 'product-reviews'
    }
}